var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingStorageSw = function SvgPHeatingStorageSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "638.1,264.1 324.1,264.1 312.1,252.1 626.1,252.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.1,259.1 319.1,259.1 317.1,257.1 631.1,257.1",
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.1,261.1 321.1,261.1 322.1,262.1 636.1,262.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.1,255.1 315.1,255.1 314.1,254.1 628.1,254.1",
    fill: "#787878"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "626.1,252.1 626.1,62.1 638.1,62.1 638.1,264.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.1,257.1 631.1,62.1 633.1,62.1 633.1,259.1",
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.1,255.1 629.1,62.1 628.1,62.1 628.1,254.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.1,261.1 635.1,62.1 636.1,62.1 636.1,262.1",
    fill: "#787878"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "324.1,264.1 324.1,330.1 312.1,330.1 312.1,252.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.1,259.1 319.1,330.1 317.1,330.1 317.1,257.1",
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.1,261.1 321.1,330.1 322.1,330.1 322.1,262.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.1,255.1 315.1,330.1 314.1,330.1 314.1,254.1",
    fill: "#787878"
  }))));
};
export default SvgPHeatingStorageSw;